import classNames from "classnames";
import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useNavigationToggle } from "../../../../contexts/NavigationContext";
import DeviceHelper from "../../../../helpers/DeviceHelper";
import Icon from "../../../atoms/Icon";
import styles from "./styles.scss";

interface Props {
  opened: boolean;
  label: string;
  iconName: string;
  link: string;
  isActive: boolean;
  collapsible?: boolean;
  visible?: boolean;
}

const NaviMenuListItem = ({
  opened = true,
  label = "",
  iconName = "",
  link = "",
  isActive = false,
  collapsible = true,
  visible = true,
}: Props) => {
  const navigate = useNavigate();
  const { toggleNavigation } = useNavigationToggle();

  const handleClick = (path: string) => (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (DeviceHelper.isPC()) {
      navigate(path);
    } else {
      toggleNavigation();
      setTimeout(() => navigate(path), 300);
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <Link
      to={link}
      onClick={handleClick(link)}
      aria-current={isActive ? "page" : undefined}
    >
      <div
        className={classNames(styles.root, {
          [styles.active]: isActive,
          [styles.opened]: opened,
          [styles.collapsible]: collapsible,
        })}
      >
        <div className={styles.iconWrapper}>
          <Icon name={iconName} className={styles.icon} />
        </div>
        <div className={styles.label}>
          <span>{label}</span>
        </div>
      </div>
    </Link>
  );
};

export default NaviMenuListItem;
